import { render, staticRenderFns } from "./ContractData.vue?vue&type=template&id=235e5b6b"
import script from "./ContractData.vue?vue&type=script&lang=js"
export * from "./ContractData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports